module.exports = __webpack_public_path__ + "static/img/fivestar_en.6a46e3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/fivestar_en.png
// module id = hBU1
// module chunks = 1